export const transformCityDto = city => ({
  id: city.id,
  title: city.title,
  countryId: city.country_id,
  isDefault: !!city.is_default
});
export const transformCityDtos = cityDtos => cityDtos.map(transformCityDto);